export const GENDER_OPTIONS = [
  { value: "", label: "Select Gender" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export const RELATION_OPTIONS = [
  { value: "Myself", label: "Myself" },
  { value: "Father", label: "Father" },
  { value: "Mother", label: "Mother" },
  { value: "Spouse", label: "Spouse" },
  { value: "Kid", label: "Kid" },
  { value: "Brother", label: "Brother" },
  { value: "Sister", label: "Sister" },
  { value: "Others", label: "Others" },
];

export const PAYMENT_METHODS = [
  { key: "Check", value: "Check" },
  { key: "Zelle", value: "Zelle" },
  { key: "Cash", value: "Cash" },
  { key: "Stripe", value: "Stripe" },
];

// Define STATUS_OPTIONS as an array of objects with key and value properties
export const STATUS_OPTIONS = [
  { key: "", value: "Select Status" },
  { key: "New", value: "New" },
  { key: "Draft", value: "Draft" },
  { key: "Wait List", value: "Wait List" },
  { key: "Pending", value: "Pending" },
  { key: "Paid", value: "Paid" },
  { key: "Approved", value: "Approved" },
  { key: "Confirmed", value: "Confirmed" },
  { key: "Cancelled", value: "Cancelled" },
  { key: "Blocked", value: "Blocked" },
  { key: "To Be Cancelled", value: "To Be Cancelled" },
];
export const REFUND_STATUSES = ["Pending", "Paid", "NA"];
export const PRAYER_REQUEST_CATEGORIES = [
  { value: "", label: "Select Category" },
  { value: "Prayer", label: "Prayer" },
  { value: "Retreats", label: "Retreats" },
  { value: "Testimony", label: "Testimony" },
  { value: "Others", label: "Others" },
];
export const PRAYER_REQUEST_STATUSES = [
  { value: "", label: "Select Status" },
  { value: "New", label: "New" },
  { value: "Actioned", label: "Actioned" },
  { value: "Pending", label: "Pending" },
  { value: "Sent to Marian", label: "Sent to Marian" },
  { value: "Blessed", label: "Blessed" },
];
export const REGIONS = [

  { value: "US", label: "USA" },
  { value: "UK", label: "UK" },
  { value: "Sweden", label: "Sweden" },
  { value: "Germany", label: "Germany" },
  { value: "Italy", label: "Italy" },
  { value: "France", label: "France" },
  { value: "India", label: "India" },
  { value: "Czech", label: "Czech" },
  { value: "Other", label: "Other" },
];
export const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "es", label: "Spanish" },
  { value: "sv", label: "Swedish" },
  { value: "de", label: "German" },
  { value: "cs", label: "Czech" },
   { value: "it", label: "Italian" },
     { value: "fr", label: "French" },
];
export const COUNTRY_OF_ORIGIN_OPTIONS = [
  { value: "IndiaK", label: "India Kerala" },
  { value: "IndiaN", label: "India Non-Kerala" },
  { value: "United States", label: "United States" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "Canada", label: "Canada" },
  { value: "Germany", label: "Germany" },
  { value: "Sweden", label: "Sweden" },
  { value: "France", label: "France" },
  { value: "Czech", label: "Czech" },
  { value: "Mexico", label: "Mexico" },
  { value: "Philippines", label: "Philippines" },
  { value: "China", label: "China" },
  { value: "Japan", label: "Japan" },
  { value: "South Korea", label: "South Korea" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "Kenya", label: "Kenya" },
  { value: "Brazil", label: "Brazil" },
  { value: "Argentina", label: "Argentina" },
  { value: "Australia", label: "Australia" },
  { value: "Italy", label: "Italy" },
  { value: "Spain", label: "Spain" },
  { value: "Poland", label: "Poland" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Thailand", label: "Thailand" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Egypt", label: "Egypt" },
  { value: "South Africa", label: "South Africa" },
  { value: "Other", label: "Other" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];
export const COUNTRY_BY_LANGUAGE = {
    sv: "SE",
    de: "DE",
    fr: "FR",
    it: "IT",
    pt: "PT",
    ru: "RU",
    zh: "CN",
    ja: "JP",
  };

export const EVENT_TYPE_OPTIONS = ["Residential", "Sabbath", "Convention", "Leaders"];
export const EVENT_STATUS_OPTIONS = ["Draft", "Confirmed", "Closed", "Cancelled"];